import create from "zustand";

interface TableState {
  isOpen: boolean;
  isOpenPdf: boolean;
  data: string;
  talhao: string;
  talhaoCode: string;
  datas: {
    PeriodoDataInicio: string;
    PeriodoDataFim: string;
  }[];

  setIsOpen: (args: boolean) => void;
  setIsOpenPdf: (args: boolean) => void;
  setData: (args: string) => void;
  setTalhao: (args: string) => void;
  setTalhaoCode: (args: string) => void;
  setDatas: (args: { PeriodoDataInicio: string; PeriodoDataFim: string }[]) => void;
}

const useShedule = create<TableState>((set) => ({
  isOpen: false,
  data: '',
  talhao: '',
  talhaoCode: '',
  isOpenPdf: false,
  datas: [],

  setIsOpen: (isOpen) => {
    set(state => ({ isOpen }));
  },

  setData: (data) => {
    set(state => ({ data }));
  },

  setTalhao: (talhao) => {
    set(state => ({ talhao }));
  },

  setTalhaoCode: (talhaoCode) => {
    set(state => ({ talhaoCode }));
  },

  setIsOpenPdf: (isOpenPdf) => {
    set(state => ({ isOpenPdf }));
  },

  setDatas: (datas) => {
    set(state => ({ datas: datas }));
  }
 
}));

export default useShedule;